import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=7bc4f64c"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@2.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/amytran/ShopifyProjects/titan22-astro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc4f64c')) {
      api.createRecord('7bc4f64c', component.options)
    } else {
      api.reload('7bc4f64c', component.options)
    }
    module.hot.accept("./accordion.vue?vue&type=template&id=7bc4f64c", function () {
      api.rerender('7bc4f64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/accordion.vue"
export default component.exports